import { render, staticRenderFns } from "./PartProgramconfigurator.vue?vue&type=template&id=0d5abab2&"
import script from "./PartProgramconfigurator.vue?vue&type=script&lang=js&"
export * from "./PartProgramconfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports